import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
  selector: 'app-icon-email-large',
  templateUrl: './icon-email-large.component.svg',
  changeDetection: ChangeDetectionStrategy.OnPush,
})
export class IconEmailLargeComponent {}
